import api from '@/api';

class ClientActionPriority {
    static list(originId) {
        return api.get('/actions/client/priorities', { params: { originId } });
    }
}

export default ClientActionPriority;
